<div
    [ngClass]="containerGutter + ' ' + containerClasses"
    class="container-fluid empty-container"
>
    <ng-content></ng-content>
</div>
